import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';

// A QR code as inline SVG. Colours come from --qr-dark / --qr-light, which are
// fixed in both themes: a QR must stay dark-on-light to scan reliably, so it must
// not follow the dark theme.
export default function QrCode({ value, size = 220, label }) {
  const { path, count } = useMemo(() => {
    const qr = qrcode(0, 'M'); // type 0 = smallest version that fits, error correction M
    qr.addData(value);
    qr.make();
    const n = qr.getModuleCount();
    let d = '';
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`;
      }
    }
    return { path: d, count: n };
  }, [value]);

  const quiet = 4; // the spec's quiet zone, in modules
  const total = count + quiet * 2;
  return (
    <svg
      className="qr-code"
      width={size}
      height={size}
      viewBox={`0 0 ${total} ${total}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label={label || `QR code for ${value}`}
    >
      <rect width={total} height={total} className="qr-code-bg" />
      <path d={path} transform={`translate(${quiet} ${quiet})`} className="qr-code-fg" />
    </svg>
  );
}
